<template>
  <form>
    <v-container class="main-container responsive-height">
      <v-row>
        <v-col xl="6" lg="7" md="7" sm="7" cols="12">
          <v-card class="deposit-form" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Transfer Method</legend>
                  <v-text-field label="Debit Credit Cards Transfer" disabled placeholder="Debit Credit Cards Transfer" single-line solo hide-details
                    readonly class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Trading Account*</legend>
                  <v-select v-model="selectedAccount" :items="formattedAccounts" item-text="display"
                    item-value="trading_account_no" solo append-icon="mdi-chevron-down" label="Select One"
                    class="custom-select" hide-details @change="handleAccountChange"></v-select>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" :md="currency.name !== 'USD' ? 6 : 12">
                <fieldset>
                  <legend>Amount in (USD)</legend>
                  <v-text-field min="1" v-model="depositAmount" label="$" type="number" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6" v-if="currency.name !== 'USD'">
                <fieldset>
                  <legend>Amount in <span :style="{ color: currency.color }">({{ currency.name }})</span></legend>
                  <v-text-field readonly v-model="currencyAmount" :label="currency.symbol" type="number" single-line solo hide-details
                    class="custom-select text-muted"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12">
                <fieldset>
                  <legend>Card Number*</legend>
                  <v-text-field min="1" v-model="card" label="Enter Card Number" type="text" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12">
                <fieldset>
                  <legend>Expiry Date *</legend>
                  <v-text-field :maxlength="7" :rules="[requiredRule, expiryRule]" inputmode="numeric" @input="formatExpiry" @keydown="restrictKeys" v-model="expiry_date" label="MM/YY" type="text" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12">
                <fieldset>
                  <legend>CVV *</legend>
                  <v-text-field min="1" v-model="cvv" label="Enter CVV" type="text" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12">
                <fieldset>
                  <legend>Commnet</legend>
                  <v-text-field v-model="comment" label="Write comment" type="text" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12" v-if="needSlip == 1">
                <div class="input-file">
                  <span>Upload Pay.Proof</span>
                  <v-file-input v-model="bankSlip" label="Choose file" filled prepend-icon="mdi-file-image"
                    hide-details></v-file-input>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-btn  @click.prevent="handleSubmit" tile elevation="0" type="submit" class="ma-0 text-capitalize btn-account d-block"
                  color="greenMain" :loading="loading" :disabled="loading">
                  Deposit
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col xl="4" lg="4" md="5" sm="5" cols="12">
          <v-card v-if="selectedAccountDetails" class="elevation-0 rounded-0 deposit-form-card mt-2"
            :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
            <v-card-actions>
              <div class="trade-status">
                <div>
                  <v-icon color="greenMain">mdi-signal</v-icon>
                </div>
                <div class="trade-number">
                  <span>MT5 - {{ selectedAccountDetails.account_type_display }} <p class="icon-badge" v-if="selectedAccountDetails.is_trade_master == 1">TRADEMASTER</p> </span>
                  <span>{{ selectedAccountDetails.trading_account_no }}</span>
                </div>
              </div>
            </v-card-actions>
            <v-card-actions>
              <div class="value-trades">
                <span>Balance</span>
                <span>{{ selectedAccountDetails.Balance }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="value-trades">
                <span>Currency</span>
                <span>{{ selectedAccountDetails.currency_name }}</span>
              </div>
            </v-card-actions>
            <v-card-actions>
              <v-sheet :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                <div>
                  <apexChart width="100%" height="95px" type="line" :options="options" :series="series" />
                </div>
              </v-sheet>
            </v-card-actions>
            <v-card-actions>
              <div class="currency-leverage">
                <span>Free Funds</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="currency-leverage">
                <span>Leverage</span>
                <span>{{ selectedAccountDetails.leverage }}:1</span>
              </div>
            </v-card-actions>
            <v-card-actions>
              <div class="balance-equity">
                <span>Free Margin</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="balance-equity">
                <span>Acc. Type</span>
                <span>{{ selectedAccountDetails.account_type_display }}</span>
              </div>
            </v-card-actions>
          </v-card>

          <v-card v-if="selectedAccountDetails?.is_trade_master == 1" class="elevation-0 rounded-0 deposit-form-card mt-2 mb-5" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
            <v-card-actions>
              <div class="value-trades">
                <p>Investment Rule</p>
              </div>
            </v-card-actions>
            <v-card-actions>
                <span class="rules-info">
                  <p class="color-white">1.First Deposit:</p>
                  <li>The first deposit must be $1,000 plus an annual fee of $110.</li>
                  <li>Total First Deposit = $1,110</li>
                </span>
            </v-card-actions>
             
            <v-card-actions>
                <span class="rules-info mt-3">
                  <p class="color-white">2.Subsequent Deposits:</p>
                  <li>Any additional deposit must be a multiple of $500.</li>
                  <li>Allowed amounts: $500, $1,000, $1,500, $2,000, etc.</li>
                  <li>Not allowed: $600, $750, $1,250, etc.</li>
                </span>
            </v-card-actions>
          </v-card>

        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { DEPOSITMETHODS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      payment_id: null,
      selectedAccount: null,
      depositAmount: '',
      currencyAmount: '',
      bankSlip: null,
      card: '',
      expiry_date: '',
      cvv: '',
      comment: '',
      loading: false,
      currency: {
        rate: 1,
        name: "USD",
        symbol: "$",
        color:"#fff"
      },
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#3A648E"],
      },
      series: [
        {
          name: "Series 1",
          data: [45, 52, 38, 45, 19, 23, 2],
        },
      ],
    };
  },

  computed: {
    ...mapState("deposit", ["accounts","needSlip"]),

    formattedAccounts() {
      return this.accounts.map(account => ({
        display: `${account.trading_account_no} (${account.account_type_display}) ${account.Balance} ${account.currency_name}`,
        trading_account_no: account.trading_account_no,
        ...account
      }));
    },

    requiredRule() {
      return v => !!v || 'Expiry date required'
    },

    expiryRule() {
      return v => {
        if (!/^\d{2}\/\d{4}$/.test(v)) return 'Format MM/YYYY';
        const [mm, yyyy] = v.split('/').map(n => parseInt(n, 10))
        if (mm < 1 || mm > 12) return 'Invalid month';

        const now = new Date()
        const exp = new Date(yyyy, mm - 1, 1)
        if (exp < new Date(now.getFullYear(), now.getMonth(), 1)) {
          return toast.error('Card expired');
        }
        return true
      }
    },

    selectedAccountDetails() {
      return this.accounts.find(acc => acc.trading_account_no === this.selectedAccount);
    },
  },

  watch: {
    depositAmount(newAmount) {
      if (this.currency && this.currency.rate) {
        this.currencyAmount = (newAmount * this.currency.rate).toFixed(2);
      } else {
        this.currencyAmount = newAmount;
      }
    }
  },

  methods: {
    ...mapActions("deposit", [
      DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS,
      DEPOSITMETHODS__ACTIONS.CREATECARDDEPOSIT,
      DEPOSITMETHODS__ACTIONS.NEEDSLIP,
    ]),

    restrictKeys(e) {
      const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab']
      if (allowed.includes(e.key)) return

      if (/\d/.test(e.key)) return
      if (e.key === '/' && !this.expiry_date.includes('/') && this.expiry_date.length >= 2) return

      e.preventDefault()
    },

    formatExpiry(e) {
      let v = (e?.target?.value ?? this.expiry_date) || ''
       
      v = v.replace(/\D/g, '').slice(0, 6)

      if (v.length <= 2) {
        this.expiry_date = v
      } else {
        this.expiry_date = `${v.slice(0, 2)}/${v.slice(2)}`
      }
    },

    handleAccountChange() {
      let account_details = this.accounts.find(acc => acc.trading_account_no === this.selectedAccount);
      
      this.depositAmount = '';
      this.currencyAmount = ''; 

      if (account_details) {
        this.currency.rate = account_details.currency_rate;
        this.currency.name = account_details.currency_name;
        this.currency.symbol = account_details.currency_symbol;
        this.currency.color = account_details.symbol_color;
      }
    },

    async handleSubmit() {
      try {
        this.loading = true;
        if (!this.selectedAccount) {
          this.loading = false;
          return toast.error('Please select a trading account');
        }
        const amount = parseFloat(this.depositAmount);
        if (isNaN(amount) || amount <= 0) {
          this.loading = false;
          return toast.error('Please enter a valid deposit amount');
        }
        if (!this.card) {
          this.loading = false;
          return toast.error('Please enter the card number');
        }
        if (!this.expiry_date || this.expiryRule(this.expiry_date) !== true) {
          this.loading = false;
          return toast.error('Please enter a valid expiry date in MM/YYYY format');
        }
        if (!this.cvv) {
          this.loading = false;
          return toast.error('Please enter the CVV');
        }
        const formData = new FormData();
        formData.append('trading_account_no', this.selectedAccount);
        formData.append('amount', this.depositAmount);
        formData.append('payment_slip', this.bankSlip);
        formData.append('payment_id', this.payment_id);
        formData.append('card_number', this.card);
        formData.append('expiry_date', this.expiry_date);
        formData.append('card_cvv', this.cvv);
        formData.append('comment', this.comment);

        await this[DEPOSITMETHODS__ACTIONS.CREATECARDDEPOSIT](formData);

      } catch (error) {
        console.error('Deposit submission error:', error?.message || error);
      } finally {
        this.loading = false;
        //this.resetForm();
      }
    },

    resetForm() {
      this.selectedAccount = null;
      this.depositAmount = '';
      this.bankSlip = null;
      this.trx = '';
      this.card = '';
      this.expiry_date = '';
      this.cvv = '';
      this.comment = '';
      this.currencyAmount = '';
      this.currency = {
        rate: 1,
        name: "USD",
        symbol: "$",
        color:"#fff"
      };
    }
  },
  
  async created() {
    this.payment_id = this.$route.query.payment_id;
    await this[DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS]();
    await this[DEPOSITMETHODS__ACTIONS.NEEDSLIP]();
  },
};
</script>

<style>
.rules-info{
  opacity: 0.5;
  font-size: 13px;
}
</style>
